<div class="success-container">
  <div class="success-card">
    <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img [src]="logoPath" alt="Nevada Department of Education Logo">
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-2 justify-content-center">
             <hr>
            </div>
        </div>
   
      
    <div class=" mt-4 mb-4 success-content">
      <div class="success-icon">
          <img src="assets/images/cardy-ai/tick logo.png" alt="tick icon" class="success-icon" >
      </div>
      <h1 class="success-title">Password updated successfully</h1>
      <p class="success-message">
        You can now sign in with your new password.
      </p>
      <div class="loading-container">
       <img src="assets/images/loading-spinner.gif" class="loading-gif" alt="loading gif">
      </div>
    </div>
  </div>
</div>